import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: '#FFFFFF !important',
          fontWeight: '600'
        }
      }
    }
  },
  typography: {
    fontFamily: [
      'sec-400'
    ].join(','),
  },
  palette: {
    type: 'dark',
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF',
      disabled: '#FFFFFF',
      link: '#FFFFFF',
      agreeTitle: '#FFFFFF',
      description: '#FFFFFF',
      checkboxTitle: '#FFFFFF',
      optionalText: '#FFFFFF',
      checkboxDescription: '#FFFFFF',
      descriptionLink: '#FFFFFF'
    },
    background: {
      default: '#000000',
      paper: '#171717',
      tooltip: '#47474A',
    },
    divider: '#8C8C8C',
  },
});

export default theme;
